import Constant from '@/const';
const axios = require('axios');

const putUpdateDrugMargin = async payload => {
  try {
    const response = await axios.put(
      Constant.apiUrl.concat('/setting/drug-margin'),
      payload,
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default putUpdateDrugMargin;
